/** @jsxImportSource react */

import { useShare } from '@common/helpers/share';
import PricingCalculatorContainer from '@react/widgets/pricingCalculator/components/PricingCalculatorContainer';
import { getFiltersFromFormValues } from '@react/widgets/pricingCalculator/helpers';
import { useRouter } from 'next/router';

import { ToolHero } from './Styles';
import { ToolDetails } from '../types';

export default function PricingCalculatorTool({
  heading,
  description,
  shortDescription,
}: ToolDetails) {
  const { query, push, pathname, asPath } = useRouter();
  const { toc, city, state, roomType, mobility, locationString } = query || {};
  const { share } = useShare();

  const handleSubmit = (values: any) => {
    const filters = getFiltersFromFormValues(values);
    const locationString = values?.location?.displayText;

    push(
      {
        pathname,
        query: {
          ...query,
          ...filters,
          roomType: values?.typeOfRoom,
          mobility: values?.mobility,
          locationString: locationString,
        },
      },
      undefined,
      { shallow: true }
    );
  };

  return (
    <>
      <ToolHero
        heading={heading}
        subheading={description}
        onShare={() => {
          share({
            title: heading,
            text: shortDescription || description || '',
            url: `${window.location.origin}${asPath}`,
          });
        }}
      />
      <PricingCalculatorContainer
        initialOptions={{
          city,
          state,
          roomType: roomType,
          toc,
          locationString: locationString,
          mobility,
        }}
        onSubmit={handleSubmit}
        hasCta={false}
        submitButtonClassName='w-full md:w-max md:ml-auto'
        submitButtonVariant='primary'
        eventProps={{ location: `${heading} tool` }}
      />
    </>
  );
}
